module.exports = __webpack_public_path__ + "img/58.211acb0c.png";